var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.33317 5.33333V9.33333C5.18066 10.2222 4.73622 10.6667 3.99984 10.6667C3.26346 10.6667 2.81901 10.2222 2.6665 9.33333V3.66667C2.6665 3.11438 3.11422 2.66667 3.6665 2.66667H9.33317C10.2221 2.66667 10.6665 3.11111 10.6665 4C10.6665 4.88889 10.2221 5.33333 9.33317 5.33333H5.33317Z",
    fill: "#ED3241"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M26.6668 26.6667L26.6668 22.6667C26.8193 21.7778 27.2638 21.3333 28.0002 21.3333C28.7365 21.3333 29.181 21.7778 29.3335 22.6667L29.3335 28C29.3335 28.7364 28.7365 29.3333 28.0002 29.3333L22.6668 29.3333C21.7779 29.3333 21.3335 28.8889 21.3335 28C21.3335 27.1111 21.7779 26.6667 22.6668 26.6667L26.6668 26.6667Z",
    fill: "#ED3241"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M26.6668 5.33333L22.6668 5.33333C21.7779 5.18082 21.3335 4.73638 21.3335 4C21.3335 3.26362 21.7779 2.81918 22.6668 2.66667L28.0002 2.66667C28.7365 2.66667 29.3335 3.26362 29.3335 4V9.33333C29.3335 10.2222 28.8891 10.6667 28.0002 10.6667C27.1113 10.6667 26.6668 10.2222 26.6668 9.33333L26.6668 5.33333Z",
    fill: "#ED3241"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.33317 26.6667L9.33317 26.6667C10.2221 26.8192 10.6665 27.2636 10.6665 28C10.6665 28.7364 10.2221 29.1808 9.33317 29.3333L3.99984 29.3333C3.26346 29.3333 2.6665 28.7364 2.6665 28L2.6665 22.6667C2.6665 21.7778 3.11095 21.3333 3.99984 21.3333C4.88873 21.3333 5.33317 21.7778 5.33317 22.6667L5.33317 26.6667Z",
    fill: "#ED3241"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 17.3333C14.0699 17.3333 14.6668 17.9303 14.6668 18.6667V21.3333C14.6668 22.0697 14.0699 22.6667 13.3335 22.6667H10.6668C9.93045 22.6667 9.3335 22.0697 9.3335 21.3333V18.6667C9.3335 17.9303 9.93045 17.3333 10.6668 17.3333H13.3335Z",
    fill: "#1F2024"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3335 17.3333C22.0699 17.3333 22.6668 17.9303 22.6668 18.6667V21.3333C22.6668 22.0697 22.0699 22.6667 21.3335 22.6667H18.6668C17.9304 22.6667 17.3335 22.0697 17.3335 21.3333V18.6667C17.3335 17.9303 17.9304 17.3333 18.6668 17.3333H21.3335Z",
    fill: "#1F2024"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 9.33333C14.0699 9.33333 14.6668 9.93029 14.6668 10.6667V13.3333C14.6668 14.0697 14.0699 14.6667 13.3335 14.6667H10.6668C9.93045 14.6667 9.3335 14.0697 9.3335 13.3333V10.6667C9.3335 9.93029 9.93045 9.33333 10.6668 9.33333H13.3335Z",
    fill: "#1F2024"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3335 9.33333C22.0699 9.33333 22.6668 9.93029 22.6668 10.6667V13.3333C22.6668 14.0697 22.0699 14.6667 21.3335 14.6667H18.6668C17.9304 14.6667 17.3335 14.0697 17.3335 13.3333V10.6667C17.3335 9.93029 17.9304 9.33333 18.6668 9.33333H21.3335Z",
    fill: "#1F2024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanFile);
export default __webpack_public_path__ + "static/media/scan-file.21963d5295e1c06c3a8ba01f7c60f56d.svg";
export { ForwardRef as ReactComponent };